import { eSSSection } from './eSSSection';
import { eTransactionCategory } from '../enums/eTransactionType';

export const getSSSectionOrder = (section: eSSSection, transactionType: eTransactionCategory): number => {
  if (transactionType === eTransactionCategory.Purchase) {
    return purchaseSpruceSSOrderMap(section);
  } else {
    return refiSpruceSSSectionOrderMap(section);
  }
};

export const purchaseSpruceSSOrderMap = (section: eSSSection): number => {
  const map = {
    [eSSSection.financial_consideration]: 0,
    [eSSSection.payoffs]: 1,
    [eSSSection.loan_charges_to_lender]: 2,
    [eSSSection.other_loan_charges]: 3,
    [eSSSection.gross_transaction_fee]: 4,
    [eSSSection.escrow_title_charges]: 5,
    [eSSSection.recording_fees_and_transfer_taxes]: 6,
    [eSSSection.prorations_adjustments]: 7,
    [eSSSection.commissions_other]: 8,
    [eSSSection.subtotals]: 9,
    [eSSSection.balance_buyer]: 10,
    [eSSSection.balance_seller]: 11,
    [eSSSection.totals]: 12,
  };

  return map[section] || map[section] === 0 ? map[section] : 50;
};

export const refiSpruceSSSectionOrderMap = (section: eSSSection): number => {
  const map = {
    [eSSSection.financial_consideration]: 0,
    [eSSSection.payoffs]: 1,
    [eSSSection.loan_charges_to_lender]: 2,
    [eSSSection.other_loan_charges]: 3,
    [eSSSection.gross_transaction_fee]: 4,
    [eSSSection.escrow_title_charges]: 5,
    [eSSSection.recording_fees_and_transfer_taxes]: 6,
    [eSSSection.prorations_adjustments]: 7,
    [eSSSection.commissions_other]: 8,
    [eSSSection.subtotals]: 9,
    [eSSSection.balance_borrower]: 10,
    [eSSSection.totals]: 11,
  };

  return map[section] || map[section] === 0 ? map[section] : 50;
};
